<template lang="pug">
  .card.has-text-centered
    .card-content
      p.is-size-6
        b Serie: 
        | &nbsp{{ articulo.serie}}
      p.is-size-7
        b Marca: 
        | &nbsp{{ articulo.marca}} 
      p.is-size-7
        b Modelo:
        | &nbsp{{ articulo.modelo }} 
      p.is-size-7 📌{{ articulo.ubicacion}}
      p.is-size-7 
      b Orden C. 
      | &nbsp{{ articulo.ordenCompra}}
      p.is-size-7 
        b Resg: 
        | &nbsp{{articulo.resguarda }}
      div.has-text-centered(v-if="articulo.subcategoria")
        .control
          .tags.has-addons
            span.tag.is-black
              i.fas.fa-tag
              | &nbsp {{ articulo.categoria}}
            span.tag.is-warning {{ articulo.subcategoria}}
      div.has-text-center(v-else)
        span.tag.is-black {{ articulo.categoria}}
      p.is-size-7.has-text-danger(v-show="articulo.observaciones")
        | &nbsp {{ articulo.observaciones }}
      a.button.is-primary.is-fullwidth(@click="agregarArticuloSalida(articulo)" :disabled="disabled")
        span 
          | Asignación
        span.icon
          i.fas.fa-share-alt 
</template>

<script>
import InventarioServices from '../../services/inventario/inventario'
import { mapState } from 'vuex'

export default {
  name: 'CardArticulo_Asign',
  props: {
    articulo: {},
    disabled: false
  },
  data () {
    return {
    }
  },
  methods: {
    agregarArticuloSalida () {
      if (!this.disabled) {
        this.$emit('asignarArticulo', this.articulo)
      }
    }
  },
  
  computed: {
    ...mapState(['userLogin'])
  }
}
</script>

<style scoped>
  .content h5 {
    margin-bottom: 0;
  }
  .card {
    border: 1px solid #00d1b2;
    -webkit-box-shadow: 2px 2px 2px 0px rgb(0, 0, 0);
    -moz-box-shadow: 2px 2px 2px 0px rgba(0,209,178,1);
    box-shadow: 2px 2px 2px 0px rgba(0,209,178,1);
  }
  .tags {
    justify-content: center;
  }
  .button.is-fullwidth {
    margin-top: 10px;
  }
</style>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/CardArticulo_Asign.vue